import React, { FC } from 'react'
import { CardGreyHeadline } from 'components/Card'
import { Spacer } from 'components/Utility'
import { FirebaseDocRefType } from 'firebase/index'
import { useQueryStoreName } from 'hooks/store'

type Props = {
  isSacriStation: boolean
  storeRef: FirebaseDocRefType
}

const ContractPlanCardHeader: FC<Props> = React.memo((props) => {
  const { isSacriStation, storeRef } = props
  const storeName = useQueryStoreName(storeRef)
  return (
    <React.Fragment>
      <CardGreyHeadline headline={isSacriStation ? `sacri station(${storeName})` : storeName} />
      <Spacer size={12} />
    </React.Fragment>
  )
})

export default ContractPlanCardHeader
